import { Col, Row, Typography, useTheme } from "@commonlibs";
import InfoPopover from "../../feedback/InfoPopover/InfoPopover";
import { AttributeCardRoot } from "../AttributeCard/AttributeCard.styles";


type KPIQueryCardType = {
    label: string;
    tooltipText: string;
    children: any;
}

export const KPIQueryCard = ({ label, children, tooltipText }: KPIQueryCardType) => {
    const { spacing } = useTheme();

    return (
        <AttributeCardRoot>
            <Col justifyContent={"center"} alignItems="center" gap={spacing[2]}>
                <Row
                    css={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="body3Strong" color="gray.300" textAlign="center">
                        { label }
                    </Typography>
                    <InfoPopover text={tooltipText} />
                </Row>
                <Row>
                    {children}
                </Row>
            </Col>
        </AttributeCardRoot>
    )
}